import _ from 'lodash';
import { getTextStylesFromBrandStyle, matchBackgroundColor } from 'modules/BrandDefinition';
import { AssetAlignmentDirection } from 'const';
import * as Models from 'models';

/**
 * Saves applied relation styles everywhere if it's possible and applies brand styles where no chance to save applied styles
 * As a result, mutates styles of the text relation
 */
export const matchAppliedStylesWithBrandStyleOnRelation = (
  textRelationStyles: Models.TextRelationStyles,
  brandStyle: Models.BrandStyleMap,
  colors: Models.BrandColorsList,
  fonts: Models.BrandFontsList,
): [Models.TextRelationStyles, boolean] => {
  const {
    alignment,
    padding,
    backgroundColor,
  } = textRelationStyles;

  const {
    padding: brandPadding,
    verticalAlignment: brandVerticalAlignment,
    backgroundColor: brandBackgroundColor,
  } = getTextStylesFromBrandStyle(brandStyle, colors, fonts);
  const brandBackgroundColorName = brandBackgroundColor ? brandBackgroundColor.get('name') : null;

  let brandStyleChanged = false;

  // VERTICAL ALIGNMENT
  const verticalAlignment = alignment[AssetAlignmentDirection.VERTICAL];

  if (!brandStyleChanged && (
    verticalAlignment !== brandVerticalAlignment)) {
    brandStyleChanged = true;
  }

  // BACKGROUND COLOR
  const updatedBackgroundColor = matchBackgroundColor(backgroundColor, colors, brandBackgroundColorName);

  if (!brandStyleChanged && updatedBackgroundColor !== brandBackgroundColorName) {
    brandStyleChanged = true;
  }

  // PADDING
  if (!brandStyleChanged && !_.isEqual(padding, brandPadding.toJS())) {
    brandStyleChanged = true;
  }

  return [{ ...textRelationStyles, backgroundColor: updatedBackgroundColor }, brandStyleChanged];
};
